// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable no-invalid-position-declaration */
.hide {
  display: none;
}

@media all and (max-width: 2463px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 2463px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1183px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1183px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 928px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 928px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 927px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 927px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 767px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

.ids-time-picker {
  display: inline-block;
  max-width: 100%;
}
.ids-time-picker ids-trigger-field,
.ids-time-picker .ids-trigger-field {
  display: inline-block;
  max-width: 100%;
}
.ids-time-picker ids-trigger-field[size=full] {
  display: block;
}
.ids-time-picker.full {
  display: block;
}
.ids-time-picker.full ids-trigger-field,
.ids-time-picker.full .ids-trigger-field {
  display: block;
}
.ids-time-picker ids-dropdown::part(trigger-field) {
  display: inline-flex;
  min-width: 75px;
}
.ids-time-picker ids-list-box,
.ids-time-picker ids-list-box-option {
  width: 100%;
}
.ids-time-picker ids-popup::part(popup) {
  margin: var(--ids-space-none);
  padding: var(--ids-space-none);
}
.ids-time-picker .dropdowns {
  display: flex;
  flex-direction: row;
  padding-inline-start: 15px;
  padding-inline-end: 15px;
  padding-top: 15px;
}
.ids-time-picker .ids-button-group {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
}
.ids-time-picker .ids-button-group .ids-button-group-section {
  display: flex;
  justify-content: center;
  flex: 1;
}
.ids-time-picker .ids-button-group .ids-button-group-section .ids-button {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.ids-time-picker .dropdown::part(trigger-field) {
  justify-content: center;
}
.ids-time-picker.is-open ids-trigger-button::part(button) {
  color: var(--ids-time-picker-button-color-background-expanded);
}
.ids-time-picker.is-open ids-trigger-field::part(field-container) {
  border-color: var(--ids-time-picker-input-color-border-expanded);
}
@media all and (max-width: 320px) {
  .ids-time-picker .dropdowns {
    flex-direction: column;
    align-items: center;
    width: var(--ids-input-width-10);
  }
  .ids-time-picker .separator {
    display: none;
  }
}
.ids-time-picker.color-variant-borderless ids-trigger-field::part(input) {
  padding-inline-end: 0 !important;
}
.ids-time-picker.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 14px;
  height: 50px;
}
.ids-time-picker.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 10px;
  height: 40px;
}
.ids-time-picker.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 6px;
  height: 35px;
}
.ids-time-picker.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 2px;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/themes/mixins/ids-hide-mixin.scss","webpack://./src/components/ids-time-picker/ids-time-picker.scss"],"names":[],"mappings":"AAAA,sDAAA;AAIA;EACE,aAAA;ACFF;;ADME;EADF;IAEI,aAAA;ECFF;AACF;;ADYE;EADF;IAEI,aAAA;ECRF;AACF;;ADkBE;EADF;IAEI,aAAA;ECdF;AACF;;ADwBE;EADF;IAEI,aAAA;ECpBF;AACF;;AD8BE;EADF;IAEI,aAAA;EC1BF;AACF;;ADoCE;EADF;IAEI,aAAA;EChCF;AACF;;AD0CE;EADF;IAEI,aAAA;ECtCF;AACF;;ADgDE;EADF;IAEI,aAAA;EC5CF;AACF;;ADsDE;EADF;IAEI,aAAA;EClDF;AACF;;AD4DE;EADF;IAEI,aAAA;ECxDF;AACF;;ADkEE;EADF;IAEI,aAAA;EC9DF;AACF;;ADwEE;EADF;IAEI,aAAA;ECpEF;AACF;;AAzEA;EACE,cAAA;AA4EF;;AAzEA;EACE,aAAA;AA4EF;;AAzEA;EACE,qBAAA;EACA,eAAA;AA4EF;AAzEE;;EAEE,qBAAA;EACA,eAAA;AA2EJ;AAvEI;EACE,cAAA;AAyEN;AArEE;EACE,cAAA;AAuEJ;AArEI;;EAEE,cAAA;AAuEN;AAlEI;EACE,oBAAA;EACA,eAAA;AAoEN;AAhEE;;EAEE,WAAA;AAkEJ;AA9DI;EACE,6BAAA;EACA,8BAAA;AAgEN;AA5DE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,iBAAA;AA8DJ;AA3DE;EACE,WAAA;EACA,sBAAA;EACA,SAAA;AA6DJ;AA3DI;EACE,aAAA;EACA,uBAAA;EACA,OAAA;AA6DN;AA3DM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AA6DR;AAxDE;EACE,uBAAA;AA0DJ;AArDI;EACE,8DAAA;AAuDN;AApDI;EACE,gEAAA;AAsDN;ADME;ECvDE;IACE,sBAAA;IACA,mBAAA;IACA,gCAAA;EAoDJ;EAjDE;IACE,aAAA;EAmDJ;AACF;AA9CI;EACE,gCAAA;AAgDN;AA5CM;EACE,oBAAA;EACA,YAAA;AA8CR;AAzCM;EACE,oBAAA;EACA,YAAA;AA2CR;AAtCM;EACE,mBAAA;EACA,YAAA;AAwCR;AAnCM;EACE,mBAAA;EACA,YAAA;AAqCR","sourcesContent":["/* stylelint-disable no-invalid-position-declaration */\n@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Includes Hidden Classes and Mixins for hiding elements at breakpoints\n.hide {\n  display: none;\n}\n\n.hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n.hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin breakpoint-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    @content;\n  }\n}\n","@use '../../themes/mixins/ids-hide-mixin' as *;\n\n:host {\n  display: block;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n.ids-time-picker {\n  display: inline-block;\n  max-width: 100%;\n\n  // Fixes input doesn't stretch to lg size and up\n  ids-trigger-field,\n  .ids-trigger-field {\n    display: inline-block;\n    max-width: 100%;\n  }\n\n  ids-trigger-field {\n    &[size='full'] {\n      display: block;\n    }\n  }\n\n  &.full {\n    display: block;\n\n    ids-trigger-field,\n    .ids-trigger-field {\n      display: block;\n    }\n  }\n\n  ids-dropdown {\n    &::part(trigger-field) {\n      display: inline-flex;\n      min-width: 75px;\n    }\n  }\n\n  ids-list-box,\n  ids-list-box-option {\n    width: 100%;\n  }\n\n  ids-popup {\n    &::part(popup) {\n      margin: var(--ids-space-none);\n      padding: var(--ids-space-none);\n    }\n  }\n\n  .dropdowns {\n    display: flex;\n    flex-direction: row;\n    padding-inline-start: 15px;\n    padding-inline-end: 15px;\n    padding-top: 15px;\n  }\n\n  .ids-button-group {\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0;\n\n    .ids-button-group-section {\n      display: flex;\n      justify-content: center;\n      flex: 1;\n\n      .ids-button {\n        width: 100%;\n        text-align: center;\n        display: flex;\n        justify-content: center;\n      }\n    }\n  }\n\n  .dropdown::part(trigger-field) {\n    justify-content: center;\n  }\n\n  // Is open state\n  &.is-open {\n    ids-trigger-button::part(button) {\n      color: var(--ids-time-picker-button-color-background-expanded);\n    }\n\n    ids-trigger-field::part(field-container) {\n      border-color: var(--ids-time-picker-input-color-border-expanded);\n    }\n  }\n\n  @include breakpoint-xs-down {\n    .dropdowns {\n      flex-direction: column;\n      align-items: center;\n      width: var(--ids-input-width-10);\n    }\n\n    .separator {\n      display: none;\n    }\n  }\n\n  // Time Picker Editor Borderless\n  &.color-variant-borderless {\n    ids-trigger-field::part(input) {\n      padding-inline-end: 0 !important;\n    }\n\n    &.field-height-lg {\n      ids-trigger-field::part(input) {\n        padding-inline: 14px;\n        height: 50px;\n      }\n    }\n\n    &.field-height-md {\n      ids-trigger-field::part(input) {\n        padding-inline: 10px;\n        height: 40px;\n      }\n    }\n\n    &.field-height-sm {\n      ids-trigger-field::part(input) {\n        padding-inline: 6px;\n        height: 35px;\n      }\n    }\n\n    &.field-height-xs {\n      ids-trigger-field::part(input) {\n        padding-inline: 2px;\n        height: 30px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
